import type { InternalCommonHost } from '../host';
import { useHost } from './use-host';

export function useFetch(): typeof globalThis.fetch {
  return useHost<InternalCommonHost>().fetch;
}
